import { createFileRoute } from '@tanstack/react-router';
import { VaultsPage } from '../components/pages/VaultsPage/VaultsPage';

export const Route = createFileRoute('/account/vaults')({
  component: VaultsPage,
});
